import React, { useState, useEffect } from "react";
import { Tabs } from "antd";
import { useLocation } from "react-router";
import { capitaliseWithHyphen } from "../../utils";
import Heading from "../../components/Heading";
import MasterRateCard from "./MasterRateCard";
import MasterRateCardList from "./MasterRateCardList";

const MasterRateCardTab = ({ rateCardType }) => {
  const { state } = useLocation();
  const [activeKey, setActiveKey] = useState(state || "1");
  const [fetchRateList, setFetchRateList] = useState(false);

  useEffect(() => {
    if (state) setActiveKey(state);
  }, [state, fetchRateList]);

  const tabItems = [
    {
      label: "Create Template",
      key: "1",
      children: (
        <MasterRateCard
          changeTab={setActiveKey}
          updatesRateList={() => setFetchRateList(!fetchRateList)}
        />
      ),
    },
    {
      label: "View Template",
      key: "2",
      children: (
        <MasterRateCardList
          changeTab={setActiveKey}
          activekey={activeKey}
          fetchRateList={fetchRateList}
        />
      ),
    },
  ];

  return (
    <div className="p-1">
      <Heading
        title={`${capitaliseWithHyphen(rateCardType)} Rate Card`}
        navigateTo="/masters"
        id={5}
      />
      <div className="rate-card-tab-container">
        <Tabs activeKey={activeKey} onChange={setActiveKey} items={tabItems} />
      </div>
    </div>
  );
};

export default MasterRateCardTab;
